// extracted by mini-css-extract-plugin
var _1 = "BulletItem-moduleBulletItem__UXnjY";
var _2 = "BulletItem-modulecontent__Ji7Rp";
var _3 = "BulletItem-moduletext__nz5rv BulletItemText-moduleBulletItemText__H1J10 Text-moduletext__Z2j5F";
export { _1 as "BulletItem", _2 as "content", _3 as "text" }
